/**
 * web-studio-sites D4 — the kit's entry, built to `/webapp/kit/v1.js`. A custom
 * page loads it after its own stylesheets:
 *
 *   <link rel="stylesheet" href="/webapp/kit/v1.css">
 *   <script type="module" src="/webapp/kit/v1.js"></script>
 *
 * It marks the page as a custom site's first, so the custom-site rules reach the
 * placed pieces, and mounts nothing until its stylesheet has loaded. It loads
 * none of Telify's own fonts and none of the website's page-wide rules.
 */
// The pieces' base first: it declares the `telify` cascade layer before any piece's CSS.
import '../styles/base.css';

import { startKit } from './runtime';

const KIT_CSS = '/webapp/kit/v1.css';

/** Resolves once the kit's stylesheet has loaded, or at once when the page did not link it. */
function stylesheetLoaded(): Promise<void> {
  const link = [...document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')].find(
    (l) => new URL(l.href, document.baseURI).pathname === KIT_CSS,
  );
  if (!link) {
    console.warn(`[telify] the kit's stylesheet is not linked; add <link rel="stylesheet" href="${KIT_CSS}"> before the kit's script.`);
    return Promise.resolve();
  }
  if (link.sheet) return Promise.resolve();
  return new Promise((resolve) => {
    link.addEventListener('load', () => resolve(), { once: true });
    link.addEventListener('error', () => resolve(), { once: true });
  });
}

document.documentElement.setAttribute('data-custom-site', '');
void stylesheetLoaded().then(() => startKit());
